// services/childcare/profile.js
import { api, uploadApi } from "./utils";

// ==================== PROFILE SERVICES ====================

// Get complete profile (all 3 tabs)
export const getCompleteProfile = async () => {
  try {
    const response = await api.get("/childcare/profile/complete");
    return response;
  } catch (error) {
    console.error("Error fetching complete profile:", error);
    throw error;
  }
};

// Get Childcare Profile
export const getChildcareProfile = async () => {
  try {
    const response = await api.get("/childcare/profile/complete");
    return response;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw error;
  }
};

// Update facility details (Tab 1)
export const updateFacilityDetails = async (facilityData) => {
  try {
    const response = await api.put("/childcare/profile/facility", facilityData);
    return response;
  } catch (error) {
    console.error("Update facility error:", error);
    throw error;
  }
};

// Update personal info (Tab 2)
export const updatePersonalInfo = async (personalData) => {
  try {
    const response = await api.put("/childcare/profile/personal", personalData);
    return response;
  } catch (error) {
    console.error("Update personal info error:", error);
    throw error;
  }
};

// ==================== FILE UPLOADS ====================

// Upload facility logo (Tab 1)
export const uploadFacilityLogo = async (file) => {
  try {
    const formData = new FormData();
    formData.append("logo", file);
    const response = await uploadApi.post(
      "/childcare/profile/upload-logo",
      formData,
    );
    return response;
  } catch (error) {
    console.error("Upload logo error:", error);
    throw error;
  }
};

// Upload facility banner (Tab 1)
export const uploadFacilityBanner = async (file) => {
  try {
    const formData = new FormData();
    formData.append("banner", file);
    const response = await uploadApi.post(
      "/childcare/profile/upload-banner",
      formData,
    );
    return response;
  } catch (error) {
    console.error("Upload banner error:", error);
    throw error;
  }
};

// Upload facility brochure (Tab 1)
export const uploadFacilityBrochure = async (file) => {
  try {
    const formData = new FormData();
    formData.append("brochure", file);
    const response = await uploadApi.post(
      "/childcare/profile/upload-brochure",
      formData,
    );
    return response;
  } catch (error) {
    console.error("Upload brochure error:", error);
    throw error;
  }
};

// Upload admin profile image (Tab 2)
export const uploadProfileImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("profile_image", file);
    const response = await uploadApi.post(
      "/childcare/profile/upload-profile-image",
      formData,
    );
    return response;
  } catch (error) {
    console.error("Upload profile image error:", error);
    throw error;
  }
};

// ==================== DELETE FILES ====================

// Delete facility logo
export const deleteFacilityLogo = async () => {
  try {
    const response = await api.delete("/childcare/profile/delete-logo");
    return response;
  } catch (error) {
    console.error("Delete logo error:", error);
    throw error;
  }
};

// Delete facility banner
export const deleteFacilityBanner = async () => {
  try {
    const response = await api.delete("/childcare/profile/delete-banner");
    return response;
  } catch (error) {
    console.error("Delete banner error:", error);
    throw error;
  }
};

// Delete facility brochure
export const deleteFacilityBrochure = async () => {
  try {
    const response = await api.delete("/childcare/profile/delete-brochure");
    return response;
  } catch (error) {
    console.error("Delete brochure error:", error);
    throw error;
  }
};

// ==================== DOCUMENTS ====================

// Get Childcare Documents
export const getChildcareDocuments = async () => {
  try {
    const response = await api.get("/childcare/documents");
    return response;
  } catch (error) {
    console.error("Error fetching documents:", error);
    throw error;
  }
};

// Upload Document
export const uploadDocument = async (file, documentData) => {
  try {
    const formData = new FormData();
    formData.append("document", file);
    formData.append("document_type", documentData.document_type);
    formData.append("document_name", documentData.document_name);
    const response = await uploadApi.post(
      "/childcare/documents/upload",
      formData,
    );
    return response;
  } catch (error) {
    console.error("Upload document error:", error);
    throw error;
  }
};

// Delete document
export const deleteDocument = async (documentId) => {
  try {
    const response = await api.delete(
      `/childcare/profile/documents/${documentId}`,
    );
    return response;
  } catch (error) {
    console.error("Delete document error:", error);
    throw error;
  }
};

// ==================== BANK DETAILS ====================

// Get Bank Details
export const getBankDetails = async () => {
  try {
    const response = await api.get("/childcare/bank-details");
    return response;
  } catch (error) {
    console.error("Error fetching bank details:", error);
    throw error;
  }
};

// Update Bank Details
export const updateBankDetails = async (bankData) => {
  try {
    const response = await api.put("/childcare/bank-details", bankData);
    return response;
  } catch (error) {
    console.error("Error updating bank details:", error);
    throw error;
  }
};

// ==================== EMAIL/PHONE UPDATE WITH OTP ====================

// Send OTP for email update
export const sendEmailUpdateOtp = async (email) => {
  try {
    const response = await api.post("/childcare/profile/send-email-otp", {
      email,
    });
    return response;
  } catch (error) {
    console.error("Send email OTP error:", error);
    throw error;
  }
};

// Send OTP for phone update
export const sendPhoneUpdateOtp = async (phone) => {
  try {
    const response = await api.post("/childcare/profile/send-phone-otp", {
      phone,
    });
    return response;
  } catch (error) {
    console.error("Send phone OTP error:", error);
    throw error;
  }
};

// Verify and update email
export const updateEmailWithOtp = async (newEmail, otp) => {
  try {
    const response = await api.put("/childcare/profile/update-email", {
      newEmail,
      otp,
    });
    return response;
  } catch (error) {
    console.error("Update email error:", error);
    throw error;
  }
};

// Verify and update phone
export const updatePhoneWithOtp = async (newPhone, otp) => {
  try {
    const response = await api.put("/childcare/profile/update-phone", {
      newPhone,
      otp,
    });
    return response;
  } catch (error) {
    console.error("Update phone error:", error);
    throw error;
  }
};

// Get verification status for profile
export const getVerificationStatusForProfile = async (type) => {
  try {
    const response = await api.get(
      `/childcare/profile/verification-status/${type}`,
    );
    return response.data;
  } catch (error) {
    console.error("Get verification status error:", error);
    return { success: true, verified: true };
  }
};

// ==================== FACILITY PHOTOS SERVICES ====================

// Upload multiple facility photos
export const uploadFacilityPhotos = async (formData) => {
  try {
    const response = await uploadApi.post(
      "/childcare/facility/photos",
      formData,
    );
    return response;
  } catch (error) {
    console.error("Upload facility photos error:", error);
    throw error;
  }
};

// Delete facility photo by ID
export const deleteFacilityPhotoById = async (photoId) => {
  try {
    const response = await api.delete(`/childcare/facility/photos/${photoId}`);
    return response;
  } catch (error) {
    console.error("Delete facility photo error:", error);
    throw error;
  }
};

// Update photo order (set primary, reorder)
export const updateFacilityPhotoOrder = async (photos) => {
  try {
    const response = await api.put("/childcare/facility/photos/order", {
      photos,
    });
    return response;
  } catch (error) {
    console.error("Update photo order error:", error);
    throw error;
  }
};

// Get all facility photos
export const getFacilityPhotos = async () => {
  try {
    const response = await api.get("/childcare/facility/photos");
    return response;
  } catch (error) {
    console.error("Get facility photos error:", error);
    throw error;
  }
};

// ==================== APPROVAL ====================

export const submitForApproval = async () => {
  try {
    const response = await api.post("/childcare/profile/submit-approval");
    return response;
  } catch (error) {
    console.error("Submit for approval error:", error);
    throw error;
  }
};

// ==================== PROFILE COMPLETION ====================

export const getProfileCompletionStatus = async () => {
  try {
    const response = await api.get("/childcare/profile/completion-status");
    return response;
  } catch (error) {
    console.error("Get completion status error:", error);
    throw error;
  }
};
